/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {GlossaireComponent} from '../../components/Glossaire';
import {Loader} from '../../components/Loader';
import {connect} from 'react-redux';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import { HeaderScreen } from '../../components/Header/HeaderScreen';

interface Props {
  lexique: any;
  route: any;
  getLexique: any;
}
export function GlossaireScreen(props: Props) {
  const {route, getLexique} = props;

  const {data, libelle} = route.params;
  const [description, setDescription] = useState('');
  const [label, setLabel] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [titleHeader, setTitleHeader] = useState(libelle);

  useEffect(() => {
    Platform.OS === 'web'
      ? setTitleHeader('Lexique > ' + libelle)
      : setTitleHeader(libelle);
    getLexique(
      {},
      (res: any) => {
        if (res && res.data) {
          res.data.description !== null
            ? setDescription(res.data.description)
            : setDescription(
                "Il n'y a pas de description disponible pour ce terme en ce moment",
              );
          setLabel(res.data.libelle);
          setLoading(false);
        }
      },
      `/${data}`,
    );
  }, []);

  return (
    <View style={{flex: 1}}>
      <HeaderScreen title={titleHeader} type="retour" noBreadcrumb={false} />
      <ScrollView style={{backgroundColor: 'rgba(0,0,0,0)', flex: 1}}>
        {isLoading ? (
          <Loader />
        ) : (
          <GlossaireComponent
            title="Lexique de l'assurance"
            word={label}
            definition={description}
          />
        )}
      </ScrollView>
    </View>
  );
}

export const Glossaire: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlossaireScreen);
